import React, {useState, useEffect, useContext, useRef} from "react";
import crmImg from "../../Assets/images/CRM.svg";
import {Link, useLocation} from "react-router-dom";
import SideMenuItem from "../SideMenu/SideMenuItem";
import {Link as ScrollLink} from "react-scroll";
import {BsChevronDown} from "react-icons/bs";
import {BsChevronUp} from "react-icons/bs";
import {SideMenuContext, createOpenMenuAction, createOpenSchemaAction, createOpenSubMenuAction, createOuterIndexAction, createActiveState} from "../../context/SideMenuContext";
import {extractTitleAndSchemaId} from "../../utils/helpers";
import {decodeMethodName, findMethodElement, scrollToElement, updateUrlWithMethodName} from "../../utils/sideBarUtils";

const NavItem = ({header, subEntities, schemas, menuIndex})=> {
  const {state, dispatch} = useContext(SideMenuContext);
  const {outerIndex, openSchema, openMenu, openSubMenu, activeState} = state;

  const highlightedElementRef = useRef(null);

  const location = useLocation();

  const method = location.hash.slice(1); // remove the '#'

  const handleOpenMenu =(entityIndex, id, methodName) => {
    updateUrlWithMethodName(methodName);
    setTimeout(()=>{
      dispatch(createOpenMenuAction(entityIndex));
      dispatch(createOuterIndexAction(menuIndex));
      dispatch(createOpenSchemaAction(-1));
      dispatch(createActiveState(Number(id)));
    }, 100);
  };

  const handleOpenSubMenu = (subEntityIndex, entityIndex, id, methodName) => {
    updateUrlWithMethodName(methodName);
    setTimeout(()=>{
      dispatch(createOpenSubMenuAction(subEntityIndex));
      dispatch(createOpenMenuAction(entityIndex));
      dispatch(createOuterIndexAction(menuIndex));
      dispatch(createOpenSchemaAction(-1));
      dispatch(createActiveState(Number(id)));
    }, 100);
  };

  useEffect(() => {
    const apiDetails = document.querySelectorAll(".api-detail");
    const headers = document.querySelectorAll(".header");


    let highestEntry = null;
    let secondHighestEntry = null;

    // Intersection observer for API details to open the corresponding menu and highlight the methods
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            // Update highest and second-highest entries
            if (!highestEntry || entry.intersectionRatio >highestEntry.intersectionRatio) {
              secondHighestEntry = highestEntry;
              highestEntry = entry;
            } else if (!secondHighestEntry || entry.intersectionRatio > secondHighestEntry.intersectionRatio) {
              secondHighestEntry = entry;
            }
          }
        });

        let selectedEntry = highestEntry;
        const isAnyIntersecting = entries.some((entry) => entry.isIntersecting);

        if (!selectedEntry && secondHighestEntry) {
          // The highest element is not intersecting, so select the second highest
          selectedEntry = secondHighestEntry;
        }

        if (selectedEntry) {
          const entry = selectedEntry;
          const index = entry.target?.getAttribute("data-index");
          const menuIndex = entry.target?.getAttribute("data-menu-index");
          const subMenuIndex = entry.target?.getAttribute("data-subMenu-index");
          const navIndex = entry.target?.getAttribute("data-open-index");
          dispatch(createOuterIndexAction(Number(navIndex)));
          dispatch(createOpenMenuAction(Number(menuIndex)));
          dispatch(createOpenSubMenuAction(Number(subMenuIndex)));
          dispatch(createOpenSchemaAction(-1));
          const id = entry.target?.id;
          dispatch(createActiveState(Number(id)));

          const idName =entry.target?.getAttribute("data-id");
          highlightedElementRef.current = document.getElementById(`${idName}sidemenu`);
        }
        if (isAnyIntersecting===false) {
          secondHighestEntry=null;
        }
        highestEntry=null;
      },
      {threshold: 0.5},
    );
    // Observing API details
    apiDetails.forEach((apiDetail) => {
      observer.observe(apiDetail);
    });
    headers.forEach((header)=>{
      observer.observe(header);
    });

    // Cleanup function to unobserve elements when the component unmounts
    return () => {
      apiDetails.forEach((apiDetail) => {
        observer.unobserve(apiDetail);
      });
      headers.forEach((header)=>{
        observer.unobserve(header);
      });
    };
  }, [openMenu]);


  useEffect(() => {
    setTimeout(() => {
      if (highlightedElementRef.current) {
        highlightedElementRef.current.scrollIntoView({behavior: "smooth", block: "center"});
      }
    }, 100);
  }, [highlightedElementRef.current]);

  useEffect(() => {
    const decodedMethod = decodeMethodName(method);
    const methodElement = findMethodElement(decodedMethod);
    scrollToElement(methodElement);
  }, [method]);
  return (
    <nav key={`menu-${menuIndex}`}>
      <ul id="toc" className="toc-list-h1">
        <li className="resource-group">
          <div className="heading">
            <img src={crmImg} alt="icon"></img>
            <Link className="toc-h1 toc-link entity-name">
              {header}
            </Link>
            <ul className="toc-list-h1">
              {subEntities&&subEntities.map(({name, tags, id}, entityIndex) => {
                return (
                  <li key={`subEntity-${entityIndex}`}>
                    {tags.length > 1 && subEntities.length > 1 && (
                      <ScrollLink
                        style={{display: "flex", justifyContent: "space-between"}}
                        activeClass="none"
                        className={
                          activeState=== id?
                            "toc-h1 toc-link side-menu-methods active":"toc-h1 toc-link side-menu-methods"}

                        id={`${name + "sidemenu"}`}
                        onClick={() => handleOpenMenu(entityIndex, id, name)}
                        to={`${id}`}
                        spy={true}
                        smooth={true}
                        offset={-150}
                        duration={0}
                      >
                        {name}
                        <span> {(openMenu === entityIndex && outerIndex===menuIndex) ? <BsChevronUp/> : <BsChevronDown/> }</span>
                      </ScrollLink>
                    )}

                    {tags.map(({name, paths, id}, subEntityIndex) => {
                      return (
                        <>
                          {((openMenu === entityIndex && outerIndex===menuIndex) ||
                             tags.length <= 1 || subEntities.length <= 1) && (
                            <ScrollLink
                              style={{display: "flex", justifyContent: "space-between"}}
                              activeClass="none"
                              className={
                                (tags.length > 1 && subEntities.length > 1) ?
                                  `toc-h2 toc-link${activeState === id ? " active" : ""}` :
                                  `toc-h1 toc-link${activeState === id ? " active" : ""}`
                              }
                              id={`${name + "sidemenu"}`}
                              onClick={() =>
                                handleOpenSubMenu(
                                  subEntityIndex,
                                  entityIndex,
                                  id,
                                  name,
                                )
                              }
                              to={`${id}`}
                              spy={true}
                              smooth={true}
                              offset={-150}
                              duration={0}
                            >
                              {name}
                              <span>{(openSubMenu === subEntityIndex &&
                              openMenu === entityIndex && outerIndex===menuIndex) ? <BsChevronUp/> : <BsChevronDown/>}</span>
                            </ScrollLink>
                          )}

                          {openSubMenu === subEntityIndex &&
                              openMenu === entityIndex && outerIndex===menuIndex &&
                              paths.map(({method, id}, methodIndex) => {
                                const {name, type} = method;
                                return (
                                  <>
                                    <SideMenuItem
                                      id={id}
                                      name={name}
                                      type={type}
                                      activeState={activeState}

                                      methodIndex={methodIndex}
                                      component = {"apiDetail"}
                                    />
                                  </>
                                );
                              })}
                        </>
                      );
                    })}
                  </li>
                );
              })}
            </ul>
          </div>
        </li>
      </ul>
    </nav>
  );
};

export default NavItem;
